export const vi = {
  login: {
    title: 'Đăng nhập',
    subtitle: 'Dùng tài khoản Google Workspace của công ty.',
    google: 'Đăng nhập với Google',
    googleUnavailable: 'Đăng nhập Google chưa được cấu hình. Liên hệ quản trị viên.',
    emergency: 'Tài khoản khẩn cấp',
    emergencyHint: 'Chỉ dùng khi không đăng nhập được bằng Google.',
    backToGoogle: 'Quay lại đăng nhập Google',
    email: 'Email',
    password: 'Mật khẩu',
    submit: 'Đăng nhập',
    totpTitle: 'Xác thực hai bước',
    totpHint: 'Nhập mã 6 chữ số trong ứng dụng xác thực.',
    totpCode: 'Mã xác thực',
    verify: 'Xác nhận',
    errors: {
      domain_not_allowed: 'Tài khoản này không thuộc domain được phép đăng nhập.',
      account_disabled: 'Tài khoản đã bị tạm khoá hoặc vô hiệu hoá. Liên hệ quản trị viên.',
      emergency_account_google:
        'Tài khoản khẩn cấp chỉ đăng nhập bằng mật khẩu và mã xác thực, không dùng Google.',
      account_not_linked:
        'Không liên kết được tài khoản Google với người dùng đã có. Liên hệ quản trị viên.',
      invalid_credentials: 'Email hoặc mật khẩu không đúng.',
      invalid_code: 'Mã xác thực không đúng hoặc đã hết hạn.',
      rate_limited: 'Thử quá nhiều lần. Vui lòng đợi ít phút rồi thử lại.',
      generic: 'Không đăng nhập được. Vui lòng thử lại.',
    },
  },
  pending: {
    title: 'Tài khoản đang chờ duyệt',
    body: 'Bạn đã đăng nhập bằng {{email}}. Quản trị viên sẽ duyệt tài khoản và phân công đơn vị cho bạn. Bạn sẽ dùng được Portal ngay sau khi được duyệt.',
    refresh: 'Kiểm tra lại',
    signOut: 'Đăng xuất',
  },
  account: {
    title: 'Tài khoản của tôi',
    description: 'Hồ sơ, tuỳ chọn hiển thị và bảo mật đăng nhập.',
    profile: 'Hồ sơ',
    organisation: 'Tổ chức',
    systemAdmin: 'Quản trị hệ thống',
    preferences: 'Tuỳ chọn',
    language: 'Ngôn ngữ',
    timezone: 'Múi giờ',
    saved: 'Đã lưu',
    security: 'Bảo mật',
    googleManaged: 'Đăng nhập và xác thực hai bước được quản lý bởi Google Workspace của công ty.',
    twoFactor: 'Xác thực hai bước (TOTP)',
    twoFactorOn: 'Đang bật',
    twoFactorOff: 'Chưa bật',
    twoFactorRequired: 'Tài khoản khẩn cấp phải bật xác thực hai bước trước khi sử dụng Portal.',
    enable: 'Bật xác thực hai bước',
    confirmPassword: 'Nhập mật khẩu để tiếp tục',
    continue: 'Tiếp tục',
    scanQr:
      'Quét mã QR bằng ứng dụng xác thực (Google Authenticator, Microsoft Authenticator…), rồi nhập mã 6 chữ số.',
    backupCodes: 'Mã dự phòng — cất ở nơi an toàn, mỗi mã dùng được một lần:',
    enabled: 'Đã bật xác thực hai bước',
    sessions: 'Phiên đăng nhập',
    sessionsHint: 'Các thiết bị đang đăng nhập bằng tài khoản của bạn.',
    thisDevice: 'Thiết bị này',
    signedIn: 'Đăng nhập lúc {{date}}',
    revoke: 'Đăng xuất',
    revokeOthers: 'Đăng xuất các thiết bị khác',
    revoked: 'Đã đăng xuất phiên',
    unknownDevice: 'Thiết bị không xác định',
  },
  users: {
    title: 'Người dùng',
    description: 'Mời, duyệt và quản lý tài khoản đăng nhập Portal.',
    invite: 'Mời người dùng',
    inviteHint: 'Người được mời đăng nhập bằng Google với đúng email này để kích hoạt tài khoản.',
    inviteSent: 'Đã gửi lời mời tới {{email}}',
    name: 'Họ tên',
    email: 'Email',
    status: 'Trạng thái',
    lastLogin: 'Đăng nhập gần nhất',
    never: 'Chưa đăng nhập',
    search: 'Tìm theo tên hoặc email…',
    columns: 'Cột',
    export: 'Xuất CSV',
    selected: 'Đã chọn {{count}}',
    all: 'Tất cả',
    admin: 'Quản trị',
    emergency: 'Khẩn cấp',
    empty: 'Không có người dùng phù hợp',
    loadError: 'Không tải được danh sách người dùng',
    retry: 'Thử lại',
    cancel: 'Huỷ',
    send: 'Gửi lời mời',
    pendingNotice_one: '{{count}} người dùng đang chờ duyệt',
    pendingNotice_other: '{{count}} người dùng đang chờ duyệt',
    review: 'Xem',
    statuses: {
      invited: 'Đã mời',
      pending_approval: 'Chờ duyệt',
      active: 'Hoạt động',
      suspended: 'Tạm khoá',
      deactivated: 'Vô hiệu hoá',
    },
    actions: {
      approve: 'Duyệt',
      reject: 'Từ chối',
      suspend: 'Tạm khoá',
      reactivate: 'Kích hoạt lại',
      deactivate: 'Vô hiệu hoá',
      resend: 'Gửi lại lời mời',
      makeAdmin: 'Cấp quyền quản trị',
      removeAdmin: 'Bỏ quyền quản trị',
    },
    confirm: {
      suspend: 'Tạm khoá {{name}}? Người dùng bị đăng xuất ngay trên mọi thiết bị.',
      deactivate:
        'Vô hiệu hoá {{name}}? Người dùng không thể đăng nhập cho tới khi được kích hoạt lại.',
      reject: 'Từ chối yêu cầu truy cập của {{name}}?',
    },
    done: 'Đã cập nhật {{name}}',
    domains: 'Domain đăng nhập',
    domainsHint:
      'Tài khoản Google Workspace thuộc các domain này có thể đăng nhập (chờ duyệt nếu chưa được mời).',
    addDomain: 'Thêm',
    domainPlaceholder: 'vd. licoglobal.net',
    removeDomain: 'Xoá',
  },
  errors: {
    // Keyed by API problem code: `core-identity.<reason>` → errors['core-identity'][reason].
    'core-identity': {
      domain_not_allowed: 'Email không thuộc domain được phép đăng nhập.',
      user_exists: 'Đã có người dùng với email này.',
      self_status_change: 'Bạn không thể đổi trạng thái tài khoản của chính mình.',
      self_demotion: 'Bạn không thể tự bỏ quyền quản trị của mình.',
      last_domain: 'Phải giữ ít nhất một domain, nếu không sẽ không ai đăng nhập được.',
      domain_exists: 'Domain đã có trong danh sách.',
    },
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  login: {
    title: 'Sign in',
    subtitle: "Use your company's Google Workspace account.",
    google: 'Sign in with Google',
    googleUnavailable: 'Google sign-in is not configured yet. Contact an administrator.',
    emergency: 'Emergency account',
    emergencyHint: 'Only when Google sign-in is unavailable.',
    backToGoogle: 'Back to Google sign-in',
    email: 'Email',
    password: 'Password',
    submit: 'Sign in',
    totpTitle: 'Two-factor authentication',
    totpHint: 'Enter the 6-digit code from your authenticator app.',
    totpCode: 'Authentication code',
    verify: 'Verify',
    errors: {
      domain_not_allowed: 'This account does not belong to an allowed domain.',
      account_disabled: 'This account is suspended or deactivated. Contact an administrator.',
      emergency_account_google:
        'Emergency accounts sign in with password and code only, not Google.',
      account_not_linked:
        'The Google account could not be linked to the existing user. Contact an administrator.',
      invalid_credentials: 'Wrong e-mail or password.',
      invalid_code: 'The code is wrong or has expired.',
      rate_limited: 'Too many attempts. Please wait a few minutes.',
      generic: 'Sign-in failed. Please try again.',
    },
  },
  pending: {
    title: 'Your account is awaiting approval',
    body: 'You signed in as {{email}}. An administrator will approve your account and assign your unit. You can use the Portal as soon as it is approved.',
    refresh: 'Check again',
    signOut: 'Sign out',
  },
  account: {
    title: 'My account',
    description: 'Profile, display preferences and sign-in security.',
    profile: 'Profile',
    organisation: 'Organisation',
    systemAdmin: 'System administrator',
    preferences: 'Preferences',
    language: 'Language',
    timezone: 'Time zone',
    saved: 'Saved',
    security: 'Security',
    googleManaged:
      "Sign-in and two-step verification are managed by the company's Google Workspace.",
    twoFactor: 'Two-factor authentication (TOTP)',
    twoFactorOn: 'On',
    twoFactorOff: 'Off',
    twoFactorRequired:
      'Emergency accounts must enable two-factor authentication before using the Portal.',
    enable: 'Enable two-factor authentication',
    confirmPassword: 'Enter your password to continue',
    continue: 'Continue',
    scanQr: 'Scan the QR code with an authenticator app, then enter the 6-digit code.',
    backupCodes: 'Backup codes — store them safely, each works once:',
    enabled: 'Two-factor authentication enabled',
    sessions: 'Sessions',
    sessionsHint: 'Devices signed in to your account.',
    thisDevice: 'This device',
    signedIn: 'Signed in {{date}}',
    revoke: 'Sign out',
    revokeOthers: 'Sign out other devices',
    revoked: 'Session signed out',
    unknownDevice: 'Unknown device',
  },
  users: {
    title: 'Users',
    description: 'Invite, approve and manage Portal accounts.',
    invite: 'Invite user',
    inviteHint:
      'The invitee signs in with Google using exactly this e-mail to activate the account.',
    inviteSent: 'Invitation sent to {{email}}',
    name: 'Name',
    email: 'Email',
    status: 'Status',
    lastLogin: 'Last sign-in',
    never: 'Never',
    search: 'Search by name or e-mail…',
    columns: 'Columns',
    export: 'Export CSV',
    selected: '{{count}} selected',
    all: 'All',
    admin: 'Admin',
    emergency: 'Emergency',
    empty: 'No matching users',
    loadError: 'Could not load users',
    retry: 'Retry',
    cancel: 'Cancel',
    send: 'Send invitation',
    pendingNotice_one: '{{count}} user is awaiting approval',
    pendingNotice_other: '{{count}} users are awaiting approval',
    review: 'Review',
    statuses: {
      invited: 'Invited',
      pending_approval: 'Pending',
      active: 'Active',
      suspended: 'Suspended',
      deactivated: 'Deactivated',
    },
    actions: {
      approve: 'Approve',
      reject: 'Reject',
      suspend: 'Suspend',
      reactivate: 'Reactivate',
      deactivate: 'Deactivate',
      resend: 'Resend invitation',
      makeAdmin: 'Make administrator',
      removeAdmin: 'Remove administrator',
    },
    confirm: {
      suspend: 'Suspend {{name}}? They are signed out on every device immediately.',
      deactivate: 'Deactivate {{name}}? They cannot sign in until reactivated.',
      reject: "Reject {{name}}'s access request?",
    },
    done: '{{name}} updated',
    domains: 'Sign-in domains',
    domainsHint:
      'Google Workspace accounts of these domains can sign in (pending approval unless invited).',
    addDomain: 'Add',
    domainPlaceholder: 'e.g. licoglobal.net',
    removeDomain: 'Remove',
  },
  errors: {
    // Keyed by API problem code: `core-identity.<reason>` → errors['core-identity'][reason].
    'core-identity': {
      domain_not_allowed: 'The e-mail is not in an allowed sign-in domain.',
      user_exists: 'A user with this e-mail already exists.',
      self_status_change: 'You cannot change the status of your own account.',
      self_demotion: 'You cannot remove your own administrator role.',
      last_domain: 'Keep at least one domain, or nobody could sign in.',
      domain_exists: 'The domain is already in the list.',
    },
    generic: 'The action failed. Please try again.',
  },
};
